import kaiusArtwork from '../data/bmc-kaius-artwork.json';
import sl9Artwork from '../data/sl9-artwork.json';
import sekaArtwork from '../data/seka-artwork.json';
import colnagoArtwork from '../data/colnago-artwork.json';

// Raster density is independent of catalogue coordinates and attachment points.
// Exact asset matching preserves custom artwork and admin colour overrides.
const upgrades = {
  '/uploads/framesets/frameset-1789067634560.png': 'black',
  '/uploads/framesets/frameset-1789067636267.png': 'white'
};

// Taped Racemax artwork replaced oversized data-URI images, which the renderer
// shrank to 740px wide; keep that display size and the HD pixels.
const tapedRacemax = {
  'perla-white': 527, 'italia-x-ink-carbon-blue': 527, 'italia-x-project-x-carbon-glossy': 527,
  'italia-x-project-x-carbon-matte': 527, 'brunito-brown': 526.97, 'seta-rose': 526.75
};

export function framesetArtwork(layer) {
  const source = (layer.image || '').trim();
  const taped = /^\/resources\/framesets\/taped-cockpits\/3t-racemax-2-made-in-italy-([a-z-]+)\.webp$/.exec(source);
  if (taped && tapedRacemax[taped[1]]) return { ...layer, renderWidth: 740, renderHeight: tapedRacemax[taped[1]] };
  if (source === kaiusArtwork.image) return { ...layer, renderWidth: kaiusArtwork.renderWidth, renderHeight: kaiusArtwork.renderHeight };
  const seka = sekaArtwork[source];
  if (seka) return { ...layer, image: seka.image, renderWidth: 708, renderHeight: 560 };
  const colnago = colnagoArtwork[source];
  if (colnago) return { ...layer, image: colnago.image, renderWidth: 708, renderHeight: 504 };
  const sl9 = sl9Artwork[source];
  if (sl9) return { ...layer, image: sl9.image, renderWidth: 708, renderHeight: 504 };
  const extrema = /^\/resources\/framesets\/3t-extrema\/([a-z-]+)\.png$/.exec(source);
  if (extrema) return { ...layer, image: `/resources/framesets/3t-extrema/${extrema[1]}-hd.webp`, renderWidth: 708, renderHeight: 560 };
  // 3T Ultra 2 Italia: 708x508 catalogue PNGs with 2x HD masters alongside.
  const ultra2 = source.match(/^(\/resources\/framesets\/ultra2-italia\/ultra2-[a-z-]+)\.png$/);
  if (ultra2) return { ...layer, image: `${ultra2[1]}-hd.webp`, renderWidth: 708, renderHeight: 508 };
  // Avona Callis 32: 740x560 catalogue PNGs with 2x HD masters alongside.
  const callis = source.match(/^(\/resources\/framesets\/avona-callis\/callis-[a-z-]+)\.png$/);
  if (callis) return { ...layer, image: `${callis[1]}-hd.webp`, renderWidth: 740, renderHeight: 560 };
  // Festka configurator colours: 708x504 catalogue PNGs with 2x HD masters.
  const festka = source.match(/^(\/resources\/framesets\/festka\/colours\/[a-z0-9-]+)\.png$/);
  if (festka) return { ...layer, image: `${festka[1]}-hd.webp`, renderWidth: 708, renderHeight: 504 };
  const color = upgrades[source];
  if (!color) return layer;
  return { ...layer,
    image: `/resources/framesets/melee-v2/${color}-hd.webp`,
    renderWidth: 708, renderHeight: 560
  };
}
